import React from "react";
import "../components/styles/Home.css";
import CodeEditor from "../components/CodeEditor";
const baseurl = "rizzapi.vercel.app/";

const GetRandom = () => {
  return (
    <section>
      <p className="heading" id="getRandom">
        🎯 Endpoints
      </p>
      <p className="endpoint">1. Get a Random Pickup Line</p>
      Method : <span className="method">GET</span>
      <div className="dbline"></div>
      URL :<span className="method">{baseurl}random</span>
      <div className="dbline"></div>
      Description :
      <div className="idea">
        Retrieve a random pickup line from the database.
      </div>
      <br />
      <div className="line"></div>
      Example Request :
      <CodeEditor>{`https://rizzapi.vercel.app/random`}</CodeEditor>
      Response:
      <CodeEditor>{`{
"_id": "65147a8b63ef48d364f9fbac",
"text": "Falling for you would be a very short trip.",
"category": "Cheesy",
"language": "English",
"tags": [],
"ratings": {
"average": 0,
"count": 0
},
"usageExamples": [],
"dateCreated": "2023-09-27T18:55:07.033Z",
"comments": [],
"__v": 0
}`}</CodeEditor>
      
      <div className="line"></div>

    </section>
  );
};

export default GetRandom;
